import React from 'react'

import {tg} from '../../styleGenerators/typography'
import {TIntrinsicElements, TTypographyPropsInner} from './types'

function TypographyInner<T extends keyof TIntrinsicElements>(
  {tag, className: outerClassName, kind, color, mobile, ...props}: TTypographyPropsInner<T>,
  ref: React.ForwardedRef<TIntrinsicElements[T] | string>,
) {
  return React.createElement(tag, {
    className: tg({className: outerClassName, kind, mobile, color}),
    ref,
    ...props,
  })
}

export const Typography = React.forwardRef(TypographyInner)

export type TTypographyProps<T extends keyof TIntrinsicElements> = React.ComponentProps<typeof Typography> &
  TTypographyPropsInner<T>

export const Text = Typography
